import Intercom from '@intercom/messenger-js-sdk'
import { config } from '@/config.settings.js'

const PROD_MUTU = 'prod-mutu'
const PROD_MUTU_SNC = 'prod-mutu-snc'

export const getInstanceServerName = (instance) => {
  const mappings = {
    'Serveur dédié Monaco': (inst) => inst.includes('mnc'),
    'Serveur mutualisé SNC': (inst) => inst === PROD_MUTU_SNC,
    'Serveur dédié SNC': (inst) => inst.includes('snc') && inst !== PROD_MUTU_SNC,
    'Serveur mutualisé': (inst) => inst === PROD_MUTU,
    'Serveur dédié': (inst) => inst.startsWith('prod-') && (inst !== PROD_MUTU_SNC || inst !== PROD_MUTU),
  }

  for (const [serverName, condition] of Object.entries(mappings)) {
    if (condition(instance)) {
      return serverName
    }
  }

  return 'Serveur mutualisé'
}

export const init = async (options) => {
  Intercom({
    app_id: config.intercom_app_id,
    region: 'eu',
    created_at: new Date(),
    Url_server: window.location.origin,
    ...options,
  })
}

export default { init }
